<div class="index" *ngIf="index > 0">
    {{ index }}
</div>
